'use strict';

const gtm = require('../modules/google/').tagManager;
const isMobile = require('../modules/util/isMobile');
const recaptchaConfig = require('../recaptchaConfig');

/**
 * @private
 * @function
 * @description Inits click event handlers
 */
function initEvents(){
    if (window.location.search.indexOf('invalid') > -1) {
        //Form validation error, means there were already changes in place
        formChanged();
    }

    initializeRecaptcha();

    // TODO: This needs a better fix.
    if (isMobile()) {
        setTimeout(function() {
            const bTop = Math.abs($('body').offset().top);

            $('iframe[title^=recaptcha]').parent().css({
                'top': bTop
            });
        }, 1500);
    }

    $('body').on('change', '#RegistrationForm input, #RegistrationForm select', formChanged);
    $('body').on('click', '.js-edit-profile-btn-submit', unsetExitConfirmation);
}

/**
 * @private
 * @function
 * @description Shows the "save changes" button and ensures changing page is subject to confirmation
 */
function formChanged(){
    $('.js-edit-profile-btn-submit').removeClass('hide');
    setExitConfirmation();
}

/**
 * @private
 * @function
 * @description Sets the event handler to ask for confirmation when exiting the page
 */
function setExitConfirmation(){
    $(window).on('beforeunload', function(){
        return true;
    });
    $('.js-account-menu-item').data('confirmPageChange', true);
}

/**
 * @private
 * @function
 * @description Unsets the event handler to ask for confirmation when exiting the page
 */
function unsetExitConfirmation(){
    $(window).off('beforeunload');
    $('.js-account-menu-item').removeData('confirmPageChange');
}

function initializeRecaptcha() {
    const recaptchaFormsAndContainers = [
        {formId: 'RegistrationForm', containerId: 'registration--recaptcha-container'},
        {formId: 'RegistrationSmsForm', containerId: 'recaptcha-container-smsregistration'},
        {formId: 'PasswordResetForm', containerId: 'recaptcha-container-resetpassword', showAfterMultipleMistakes: true},
    ];
    const recaptchaDefinitions = [];

    recaptchaFormsAndContainers.forEach(function(el) {
        const recaptchaContainerId = el.containerId;
        const recaptchaContainer = $('#' + recaptchaContainerId);
        if (!recaptchaContainer.length) {
            return;
        }

        let showRecaptcha = true;
        if (el.showAfterMultipleMistakes) {
            // For some pages recaptcha is shown only after couple of user mistakes (RateLimiter on BE).
            // recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS class indicates that recaptcha should not be forced yet (session.privacy.showCaptcha)
            showRecaptcha = !recaptchaContainer.hasClass(recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS);
        }

        if (showRecaptcha) {
            const form = $('#' + el.formId);
            recaptchaDefinitions.push(recaptchaConfig.buildContainerDefinition(form, recaptchaContainerId, recaptchaConfig.defaultVerifyHandler));
            form.addClass(recaptchaConfig.CONSTANTS.FORM_EXECUTE_RECAPTCHA_CLASS);
            form.data(recaptchaConfig.CONSTANTS.RECAPTCHA_CONTAINER_ID_ATTR, recaptchaContainerId);
        }
    });

    if (recaptchaDefinitions.length) {
        recaptchaConfig.init(recaptchaDefinitions);
    }
}

const init = function () {
    initEvents();

    //Only set up form error events for loyalty customers
    if ($('form input[type=hidden][name*=customer_loyalty]').length > 0) {
        gtm.bindFormFieldErrorEvents();
    }
};

exports.init = init;
